import { render, staticRenderFns } from "./EventTaskSetting.vue?vue&type=template&id=8d21f964"
import script from "./EventTaskSetting.vue?vue&type=script&lang=js"
export * from "./EventTaskSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports